import type { Feature } from '@/shared/registry'

import { diagnosticsPath } from './paths'

/** API diagnostics: a page for Super Users, linked from Admin Home's Web Application category. */
export const feature: Feature = {
  id: 'diagnostics',
  routes: [
    {
      path: diagnosticsPath,
      titleId: 'diagnostics.title',
      page: () => import('./DiagnosticsPage').then((module) => module.DiagnosticsPage),
    },
  ],
  adminHome: {
    links: [
      { id: 'api-diagnostics', category: 'web-application', labelId: 'diagnostics.title', path: diagnosticsPath, isSuperUserOnly: true },
    ],
  },
}
